import {request} from '../../helpers/request'
import {Grid, Row, Col} from 'react-bootstrap'
import React from 'react'
import {Table} from 'react-bootstrap'
import _ from 'lodash'
import {t} from '../../helpers/translate.js'
import axios, { post } from 'axios';
let config = require('config');

class Document extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      data: '',
      value: '',
      attachment: '',
      description: '',
      files: null,
      selectedFile: null,
      saving: false,
    };
  }

  renderAttachments (){
    return (
      <tbody>
      {this.props.attachments.map(
        (attachment, index) => {
          return (
            <tr key={index}>
              {this.renderTableCell(attachment.filename)}
              {this.renderDownloadCell(attachment.id)}
            </tr>
          )
        })}
      </tbody>
    )
  }

  renderDownloadCell(link) {
    return <td>
      <button 
        className="btn button-primary" 
        onClick={this.getS3TemporaryLink.bind(this, link)} 
      >
        Download File
      </button>
    </td>
  }

  renderTableCell (value) {
    return <td>{value}</td>
  }

  getS3TemporaryLink(link) {
    let succ = true;
    request(`${config.default.api}/getS3TempClaimLink/${link}`,
      'GET',
      null,
      function (data, status) {
        if (status == 200) {
          if(succ){
            window.open(data.signed_url, "_blank");
          }
        }
      }.bind(this),
      { 'Content-Type': 'application/json'}
    );
  }

  render() {
    const tableHead = [t('Filename'), t('Link') ];
    
    return <div>
      {
        this.props.attachments.length > 0 &&
        <Table striped condensed hover id='attachmentTable'>
          <thead>
            <tr>
            {tableHead.map((th, index) => <th key={index}>{t(th)}</th>)}
            </tr>
          </thead>
          { this.renderAttachments() }
        </Table>
      }
    </div>
  }
}
Document.displayName = 'Document';
export default Document;



// WEBPACK FOOTER //
// ./src/components/common/Document.js